/**
 * Automatically imports all the modules and exports as a single module object
 */
import VuexHelper from '@/utilities/service/vuex/Helper'

const helper = new VuexHelper(require.context('.', true, /index\.js$/))
export default helper.modules()
